var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-shared-list-item-line",style:(_vm.style),attrs:{"id":("story-line-" + _vm.current)}})}
var staticRenderFns = []

export { render, staticRenderFns }